var _rect, _rect2, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "more_svg__mask0_9773_32872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 80,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#more_svg__mask0_9773_32872)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "more_svg__mask1_9773_32872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 5,
    width: 71,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9336,
    y: 5.625,
    width: 69.5047,
    height: 69.375,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#more_svg__mask1_9773_32872)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4155 39.4574L52.8059 46.8593C51.035 47.1743 49.8557 48.8644 50.172 50.6343L52.1682 61.8059C52.4844 63.5757 54.1764 64.7551 55.9473 64.4401L97.5569 57.0382C99.3278 56.7232 100.507 55.033 100.191 53.2632L98.1946 42.0916C97.8784 40.3217 96.1864 39.1424 94.4155 39.4574Z",
    fill: "url(#more_svg__paint0_linear_9773_32872)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1167 21.8092L47.1791 48.2586C45.7773 49.3843 45.5549 51.4331 46.6823 52.8346L53.799 61.6812C54.9265 63.0828 56.9769 63.3064 58.3787 62.1807L91.3163 35.7313C92.7181 34.6056 92.9406 32.5568 91.8131 31.1553L84.6964 22.3087C83.569 20.9071 81.5186 20.6835 80.1167 21.8092Z",
    fill: "url(#more_svg__paint1_linear_9773_32872)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1624 14.8356L44.827 54.9008C44.2594 56.606 45.1833 58.4492 46.8906 59.0178L57.667 62.6067C59.3743 63.1753 61.2184 62.2539 61.786 60.5487L75.1214 20.4836C75.6889 18.7784 74.765 16.9352 73.0577 16.3666L62.2813 12.7777C60.574 12.2091 58.7299 13.1305 58.1624 14.8356Z",
    fill: "url(#more_svg__paint2_linear_9773_32872)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "more_svg__mask2_9773_32872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 16,
    width: 32,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1048 23.8285L45.9203 64.0832C46.4657 65.7965 48.298 66.7454 50.0128 66.2027L60.8368 62.777C62.5516 62.2343 63.4996 60.4055 62.9542 58.6922L50.1387 18.4375C49.5933 16.7243 47.761 15.7754 46.0462 16.3181L35.2222 19.7438C33.5073 20.2865 32.5594 22.1153 33.1048 23.8285Z",
    fill: "#65CDD8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#more_svg__mask2_9773_32872)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#more_svg__filter0_f_9773_32872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-82.7723 71.1051C-79.6676 77.9345 -76.4743 84.7421 -73.4139 91.5825C-70.4612 98.0826 -65.0555 97.9357 -49.2473 93.8335C-12.8903 84.3622 23.8 75.5057 60.4067 66.4681C66.7338 64.8997 70.9841 61.7169 69.8964 59.3617C62.1608 42.6119 54.4177 25.8456 46.7706 9.07381L-82.7723 71.1051Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#more_svg__filter1_f_9773_32872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5927 59.2746C27.4707 60.2353 26.9597 60.7387 26.5949 61.9082C25.053 63.1112 26.763 63.7914 28.2338 63.301C30.305 62.6103 29.9367 61.6415 30.7191 60.4715C32.0912 58.4199 32.7549 57.0022 34.7011 54.9606C36.1312 53.4603 40.8115 51.1421 42.8773 50.2735C45.9546 48.9796 45.7763 45.3013 46.4734 43.4015C47.4777 40.6638 47.2048 38.4972 49.5433 35.7229C51.8605 32.974 55.1769 30.7419 58.1274 28.3728C61.3916 25.7519 63.7912 23.7739 65.0412 20.3668C66.102 17.4751 62.8474 16.9673 60.971 16.1218C59.123 15.289 54.8438 17.167 52.5219 18.0387C49.5177 19.1665 47.8958 20.6855 45.5444 22.6662C42.9269 24.8709 42.3433 28.2126 39.8217 30.3366C37.8186 32.0237 33.3598 34.4697 32.9077 36.7251C32.0155 41.1753 32.7031 44.6085 28.3111 49.2159C26.6363 50.9728 27.3868 54.1311 27.6579 55.7362C27.8706 56.9959 27.7591 57.9637 27.5927 59.2746Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#more_svg__filter2_f_9773_32872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2775 49.4569C49.3868 43.1317 60.1903 31.9753 63.0188 23.7263C57.2533 21.9306 57.1236 34.0705 51.3581 32.2748L40.9805 42.8863C39.3171 47.3877 37.2612 47.8945 42.2775 49.4569Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#more_svg__filter3_f_9773_32872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9699 77.1849C40.1533 77.5542 40.5781 77.7941 40.7732 78.1796C40.9683 78.565 41.4387 79.6084 41.7136 79.7086C42.1108 79.8534 42.546 80.3461 43.1586 80.063C43.7507 79.7894 44.1267 79.0874 44.4599 78.6008C45.6832 76.8148 46.4699 74.8204 47.4626 72.9632C47.9646 72.024 48.7439 71.1918 49.3088 70.26C49.5841 69.8059 49.5243 69.4735 49.9462 69.0374C50.3514 68.6187 50.5954 68.1376 50.8794 67.6692C51.5665 66.5358 52.5803 65.7142 53.5896 64.7385C54.7039 63.6614 55.5718 61.8578 56.1653 60.5849C58.0617 56.5172 57.1761 52.6185 57.4139 48.5998C57.5061 47.0409 57.2055 45.5437 57.4815 43.9629C57.7722 42.2978 58.6724 40.7814 59.6129 39.23C61.2168 36.5843 63.082 33.7104 63.9435 30.9075C64.3427 29.6086 64.5194 28.3728 64.0196 27.1693C63.4808 25.872 60.7512 25.1991 59.055 25.5094C58.1132 25.6817 56.7998 26.6959 56.0823 27.2567C55.3213 27.8516 54.6442 28.5023 53.9815 29.1631C51.5069 31.6302 50.0296 34.7147 49.2619 37.6519C48.2981 41.3391 45.4473 43.9298 43.1699 47.2068C42.0773 48.7789 41.2555 50.4282 40.4256 52.0571C39.8754 53.1367 40.3142 54.476 40.2953 55.5424C40.2421 58.5389 41.6624 61.1498 40.85 64.2105C40.4729 65.6314 39.9987 67.0861 39.2064 68.443C38.7754 69.181 38.099 70.2731 38.1286 71.0765C38.1835 72.57 38.0558 74.3709 39.0158 75.6024C39.3659 76.0515 39.7251 76.6917 39.9699 77.1849Z",
    fill: "#FFE665"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "more_svg__filter0_f_9773_32872",
    x: -86.7722,
    y: 5.07385,
    width: 160.838,
    height: 95.6495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "more_svg__filter1_f_9773_32872",
    x: 21.988,
    y: 11.9137,
    width: 47.2607,
    height: 55.5479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "more_svg__filter2_f_9773_32872",
    x: 35.1162,
    y: 19.5446,
    width: 31.9026,
    height: 33.9124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "more_svg__filter3_f_9773_32872",
    x: 34.1277,
    y: 21.4344,
    width: 34.1975,
    height: 62.7147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "more_svg__paint0_linear_9773_32872",
    x1: 59.6259,
    y1: 57.2883,
    x2: 64.2956,
    y2: 30.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "more_svg__paint1_linear_9773_32872",
    x1: 53.6925,
    y1: 50.5211,
    x2: 51.3816,
    y2: 22.8007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "more_svg__paint2_linear_9773_32872",
    x1: 43.8021,
    y1: 53.621,
    x2: 28.4738,
    y2: 24.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgMore;